/* eslint-disable */

import $ from 'jquery';

export default () => {
  $('.field--name-field-paragraph-slideshow').slick({
    dots: true,
    arrows: false,
    adaptiveHeight: false,
    swipeToSlide: true,
    centerMode: true,
    centerPadding: 0,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  $('.field--name-field-paragraph-review').slick({
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    swipeToSlide: true,
    centerMode: true,
    centerPadding: 0,
  });
};

/* eslint-enable */
